export enum ActionType {
    CallMethod = "CallMethod",
    CallScript = "CallScript",
    IncrementValue = "IncrementValue",
    SendMail = "SendMail",
    SendSMS = "SendSMS",
    SendWFMessage = "SendWFMessage",
    SetAttribute = "SetAttribute",
    SetObjectAttribute = "SetObjectAttribute",
    SetValue = "SetValue",
    OpenForm = "OpenForm",
}

export enum TriggerType {
    AttributeDataChange = "AttributeDataChange",
    Menu = "Menu",
    NewObject = "NewObject",
    WfMessage = "WfMessage",
}

export enum ParticipantType {
    Role = "Role",
    User = "User",
    System = "System",
    DefinitionParticipant = "DefinitionParticipant",
    Owner = "Owner",
}

export enum EditDialogType {
    Set = "Set",
    Activity = "Activity",
    Transition = "Transition",
    DefinitionParticipants = "DefinitionParticipants",
}

/** Mód, ve kterém se editor WF spouští. */
export enum WorkflowEditorMode {
    Editor = 0,
    Viewer = 1 << 0,
    StatusViewer = Viewer | 1 << 1,
}

/** Indexy tabů pro editační dialog aktivity. */
export enum ActivityEditDialogTabsIndex {
    Properties = 0,
    FromTo = 1,
    Actions = 2,
    Triggers = 3,
    Participants = 4,
}

/** Indexy tabů pro editační dialog propojení. */
export enum TransitionEditDialogTabsIndex {
    Properties = 0,
    Actions = 1,
}
